import { useQuery } from '@tanstack/react-query'

import type { OrderWithOwnerStripeUrl, OrderWithStock } from '@snootsvet/shared'

import { useOsApi } from '@/frontend/hooks/api/use-os-api'

interface BaseOptions {
  enabled?: boolean
  refetchInterval?: number
}

/** Fetches orders for a patient. When include is 'stock', each order's product includes its stock rows. */
export function useListPatientOrders(
  patientId: string,
  options: BaseOptions & { include: 'stock' }
): ReturnType<typeof useQuery<OrderWithStock[]>>

export function useListPatientOrders(
  patientId: string,
  options?: BaseOptions
): ReturnType<typeof useQuery<OrderWithOwnerStripeUrl[]>>

export function useListPatientOrders(
  patientId: string,
  options?: BaseOptions & { include?: 'stock' }
) {
  const api = useOsApi()
  const { enabled, refetchInterval, include } = options ?? {}

  return useQuery({
    queryKey: ['patient-orders', patientId, { include }],
    queryFn: async () => {
      const response = await api.get('/orders', { query: { patientId, include } })
      if (!response.success) throw new Error(response.error.message)
      return response.data.orders
    },
    enabled,
    refetchInterval,
  })
}
